import React, {Component} from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {withStyles} from "@material-ui/core/styles";
import ListDesignerHoc from "../../../../../../HocHelpers/ListDesignerHoc";
import AceEditor from "react-ace";
import "mongodb-ace-mode"
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/webpack-resolver";
import Confirmation from "../../../../../../Utils/Confirmation/Confirmation";

const styles = () => ({
    root: {
        '&:first-child': {
            paddingTop: 0,
        },
    },
    dividers: {
        padding: 0,
    },
});

class JsonEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentQuery: '',
            isEdited: false,
            openConfirmation: false,
        }
    }

    dataSourceChange = (value) => {
        this.setState({currentQuery: value, isEdited: true});
    };

    componentDidMount() {
        const {values} = this.props;
        this.setState({currentQuery: values.source.query})
    };

    handleClose = () => {
        const {onClose, values} = this.props;
        const {isEdited} = this.state;
        if(!isEdited){
            this.setState({currentQuery: values.source.query});
            onClose();
        }else{
            this.setState({openConfirmation: true})
        }
    };
    submitClose = () => {
        const {onClose, values} = this.props;
        this.setState({currentQuery: values.source.query, isEdited: false, openConfirmation: false});
        onClose();
    };

    saveQuery = () => {
        const {currentQuery} = this.state;
        const {onClose, saveQuery} = this.props;
        this.setState({isEdited: false});
        saveQuery(currentQuery.replace(/\r/g, ''));
        onClose();
    };

    render() {
        const {open, onClose, classes} = this.props;
        const {currentQuery, openConfirmation} = this.state;

        return (
            <div>
                <Dialog onClose={this.handleClose}
                        aria-labelledby="customized-dialog-title"
                        open={open}
                        fullWidth={true}
                        maxWidth="md"
                >
                    <DialogContent dividers id="customized-dialog-title" onClose={onClose}
                                   classes={{
                                       root: classes.root,
                                       dividers: classes.dividers
                                   }}>
                        <AceEditor
                            style={{width: '100%'}}
                            mode="mongodb"
                            theme="github"
                            focus
                            value={currentQuery}
                            onChange={(value, stat) => this.dataSourceChange(value, stat)}
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{$blockScrolling: true}}
                            setOptions={{
                                enableBasicAutocompletion: true,
                                enableLiveAutocompletion: true,
                                enableSnippets: true,
                                useWorker: false
                            }}
                        />
                    </DialogContent>
                    <DialogActions style={{padding: 4}}>
                        <Button variant="contained" onClick={this.saveQuery} color="primary">
                            Apply
                        </Button>
                        <Button variant="contained" onClick={this.handleClose} color="default">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Confirmation
                    open={openConfirmation}
                    submit={this.submitClose}
                    close={() => this.setState({openConfirmation: false})}
                >
                    <span>The record has been changed, do you want to exit without saving?</span>
                </Confirmation>
            </div>
        );
    }
}

export default ListDesignerHoc(withStyles(styles)(JsonEditor));